import $ from "jquery";
import "jquery-validation";

$(() => {
  function updateMainPaddingTop() {
    const headerHeight = $(".header").outerHeight() || 0;
    $(".main").css("padding-top", headerHeight + "px");
  }

  $(window).on("resize", () => {
    updateMainPaddingTop();
  });

  function updateFadein() {
    $(".fadein").each(function() {
      const $this = $(this);
      if ($this.hasClass("scrollin")) {
        return;
      }
      const elemPos = $this.offset()?.top || 0;
      const $window = $(window);
      const scroll = $window.scrollTop() || 0;
      const windowHeight = $window.height() || 0;
      if (scroll > elemPos - windowHeight) {
        $this.addClass("scrollin");
      }
    });
  }

  $(window).on("scroll", () => {
    updateFadein();
  });

  $("a[href^='./#']").on("click", function() {
    const href = $(this).attr("href")?.replace("./", "");
    const target = $(href == "#" || href == "" || !href ? "html" : href);
    const position = target.offset()?.top;
    if (position === undefined) {
      return false;
    }
    const headerHeight = $(".header").outerHeight() || 0;
    const margin = href == "#about"? 0 : 0;
    $("html, body").animate({ scrollTop: Math.max(position - headerHeight - margin, 0) }, 300, "swing");
    return false;
  });

  $(".header__nav-button").on("click", () => {
    if ($(".header__nav").hasClass("show")) {
      $(".header__nav-button").removeClass("on");
      $(".header__nav").removeClass("on").removeClass("show");
    } else {
      $(".header__nav").addClass("on");
      $(".header__nav-button").addClass("on");
      setTimeout(() => {
        $(".header__nav").addClass("show");
      });
    }
  });

  $(".header__nav a").on("click", () => {
    $(".header__nav").removeClass("on").removeClass("show");
    $(".header__nav-button").removeClass("on");
  });

  console.log($(".top__s5-form form").length);

  let submitting = false;
  let submitted = false;
  $(".top__s5-form form").validate({
    messages: {
      "entry.1728792941": "お名前を入力してください",
      "entry.270114185": "メールアドレスを入力してください",
      "entry.1715883152": "件名を入力してください",
      "entry.1395738012": "メッセージを入力してください",
    },
    errorElement: "div",
    errorClass: "top__s5-form-validation-error",
    errorPlacement: function(error: any, element: JQuery<HTMLElement>) {
      element.after(error);
    },
    submitHandler: function(form: HTMLFormElement) {
      if (submitting) {
        return;
      }
      submitting = true;
      form.submit();
    }
  });

  $("#form-result").on("load", () => {
    submitted = true;

    $(".top__s5-form form").hide();
    $(".top__s5-form-message").text("送信しました。").show();
  });

  updateMainPaddingTop();
  updateFadein();
  // $(".header__nav").addClass("on").addClass("show");
});
